import { Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export function LoadingDot() {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev >= 3 ? 1 : prev + 1));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dots = '.'.repeat(dotCount).padEnd(3, ' ');

  return (
    <Text as="span" whiteSpace="pre">
      {dots}
    </Text>
  );
}
